import { ANIMATION_STATE } from "../consts";
class RunningState {
    name;
    animationController;
    /** The running state, usually following the walking state. */
    constructor(animationController) {
        this.name = ANIMATION_STATE.RUN;
        this.animationController = animationController;
    }
    /**
     * Enter the running state. Handle interpolation between different states.
     * @param previousState The state from which we entered. If none is provded, the animation is just played normally.
     */
    enter(previousState) {
        const currentAction = this.animationController.getAnimations[this.name].action;
        if (!previousState) {
            currentAction.play();
            return;
        }
        const previousAction = this.animationController.getAnimations[previousState.name].action;
        currentAction.enabled = true;
        if (previousState.name === ANIMATION_STATE.WALK) {
            const ratio = currentAction.getClip().duration / previousAction.getClip().duration;
            currentAction.time = previousAction.time * ratio;
        }
        else {
            currentAction.time = 0.0;
            currentAction.setEffectiveTimeScale(1.0);
            currentAction.setEffectiveWeight(1.0);
        }
        currentAction.crossFadeFrom(previousAction, 0.5, true);
        currentAction.play();
    }
    /**
     * Exit the running state.
     */
    exit() { }
    /**
     * Perform an update on the walking state
     * @param deltaTime The current value of the delta timer.
     * @param input A character controller input.
     * @param setState A function that changes the states of the finite state machine.
     */
    update(deltaTime, input, setState) {
        if (input.getFORWARD || input.getBACK) {
            if (!input.getRUNNING) {
                setState(ANIMATION_STATE.WALK);
            }
            return;
        }
        setState(ANIMATION_STATE.IDLE);
    }
}
export { RunningState };
